<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('systemlog.titlelab')">
        <el-input :placeholder="$t('systemlog.titlelab')" v-model="filter.title" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('systemlog.logType')">
        <el-select v-model="filter.logType" class="input-mini">
          <el-option label="all" :value="-1"></el-option>
          <el-option label="info" :value="0"></el-option>
          <el-option label="warn" :value="1"></el-option>
          <el-option label="error" :value="2"></el-option>
          <el-option label="fatal" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t('publics.querybtn') }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading" stripe>
      <el-table-column type="index" width="50" align="center"></el-table-column>
      <el-table-column :label="$t('systemlog.title')" prop="Title"></el-table-column>
      <el-table-column :label="$t('systemlog.logType')" prop="LogType" width="100">
        <template slot-scope="{row}">
          <el-tag v-if="row.LogType == 0" type="info">info</el-tag>
          <el-tag v-else-if="row.LogType == 1" type="warning">warn</el-tag>
          <el-tag v-else-if="row.LogType == 2" type="danger">error</el-tag>
          <el-tag v-else-if="row.LogType == 3" type="info">fatal</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('systemlog.AppName')" prop="AppName" width="150"></el-table-column>
      <el-table-column :label="$t('systemlog.Content')" prop="Content" width="700"></el-table-column>
      <el-table-column :label="$t('systemlog.Uname')" prop="Uname" width="100"></el-table-column>
      <el-table-column :label="$t('systemlog.timespan')" prop="timespan" width="160"></el-table-column>
      <el-table-column :label="$t('systemlog.TraceId')" prop="TraceId" width="190"
        show-overflow-tooltip></el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

  </div>
</template>

<script>
import pageMixin from '@/mixins/pageMixin';
import { getSystemLog } from '@/api/user';
export default {
  name: 'SystemLog',
  mixins: [pageMixin],
  data() {
    return {
      tableData: [],
      loading: false,
      filter: {
        title: '',
        logType: -1
      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      getSystemLog({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        title: this.filter.title,
        logType: this.filter.logType
      }).then(res => {
        if (res.status) {
          this.tableData = res.outputData;
          this.pageParams.total = res.Total;
        }
      }).finally(() => { this.loading = false; })
    }
  }
}
</script>

<style scoped></style>